import React from 'react';
import Title from './Title';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import {Box, Text} from '../../../../styled';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';

const Dropbox = ({ item, isPreview }: any) => {
  const files = [{...item}];
  const ownership = !item.shared ? `Owned by ${item.dropbox_account}` : `Shared with ${item.dropbox_account}`;

  if (isPreview) {
    return (
      <Box>
        <Box display="flex" alignItems="center">
          <Box mr={20}>
            <EntityIcon entityName={item.pl} />
          </Box>
          <Title item={item} />
        </Box>
        <Box ml={[0, 60]} mt={40}>
          <FileAttachments files={files} />
          <Text variant="muted" size='small'>
            {ownership} {item.date ? `| ${item.date}` : ''}
          </Text>
        </Box>
      </Box>
    )
  }
  return (
    <>
      <Title item={item} />
      <Box mt={20}>
        <FileAttachments files={files} />
        <Text variant="muted" size='small'>
          {ownership} {item.date ? `| ${item.date}` : ''}
        </Text>
      </Box>
    </>
  )
}

export default Dropbox